import { jsx as c } from "react/jsx-runtime";
import * as a from "react";
import { T as d } from "../../index-Dk8sDeUp.js";
const g = ({ theme: e, ...o }) => {
  const [m, t] = a.useState("light");
  return a.useEffect(() => {
    if (e !== "system" && e) return;
    const r = window.matchMedia("(prefers-color-scheme: dark)");
    t(r.matches ? "dark" : "light");
    const s = (n) => {
      t(n.matches ? "dark" : "light");
    };
    return r.addEventListener("change", s), () => r.removeEventListener("change", s);
  }, [e]), /* @__PURE__ */ c(
    d,
    {
      theme: e === "system" || !e ? m : e,
      className: "toaster group",
      style: {
        "--normal-bg": "var(--primary)",
        "--normal-text": "var(--primary-foreground)",
        "--normal-border": "var(--border)"
      },
      ...o
    }
  );
};
export {
  g as Toaster
};
//# sourceMappingURL=sonner.js.map
